import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface IProfilePicture {
  dataUrl: string;
  providerId: string;
  fetchedTime: string | null;
}

export interface IProfilePictureSlice {
  profilePictures: IProfilePicture[];
}

const initialState: IProfilePictureSlice = {
  profilePictures: []
};

export const profilePictureSlice = createSlice({
  name: 'profileData',
  initialState,
  reducers: {
    setProfileData: (state, action: PayloadAction<IProfilePicture>) => {
      state.profilePictures.push(action.payload);
    }
  }
});

export const {
  actions: profilePictureActions,
  reducer: profilePictureReducer
} = profilePictureSlice;
